
export interface NotificationDialogData {
  id: string;
  userId: string;
  name: string;
  notification?: NotificationConfig;
}

export interface IButton {
  action: string;
  text: string;
  redirectUrl: string | null;
}

export interface NotificationConfig {
  id:            number;
  companyId:     string;
  userId:        string | null;
  modalId:       number;
  modalType:     number;
  title:         string;
  content:       string;
  contentType:   'image' | 'video' | 'text';
  data:          string | IButton[];
  footer?:       string;
  startDate:     string;
  endDate:       string;
  manyTimes?:    number;
  modalLocation: string;
  state?: {
    opened:   number;
    accepted: boolean;
  };
}

export const ModalType = { REDIRECT: 0, INTERACTIVE: 1, INFORMATIVE: 2 } as const;
export const typePriority: Record<number, number> = {
  [ModalType.REDIRECT]:     1,
  [ModalType.INTERACTIVE]:  2,
  [ModalType.INFORMATIVE]:  3
};
